"use client";

import { MouseEvent, useState } from "react";
import SignModal from "@/components/sign/modal";

type RootSignInTriggerProps = {
  className: string;
  closeMenuOnOpen?: boolean;
};

export default function RootSignInTrigger({
  className,
  closeMenuOnOpen = false,
}: RootSignInTriggerProps) {
  const [open, setOpen] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (closeMenuOnOpen) {
      const details = event.currentTarget.closest("details");
      if (details instanceof HTMLDetailsElement) {
        details.open = false;
      }
    }

    setOpen(true);
  };

  return (
    <>
      <button type="button" onClick={handleClick} className={className}>
        Sign In
      </button>
      <SignModal open={open} onOpenChange={setOpen} />
    </>
  );
}
